<template>
  <v-app>
    <div class="text-right"
         style="direction: rtl">
      <vue-page-transition>
        <router-view>
        </router-view>
      </vue-page-transition>
      <v-fab-transition>
        <a href="https://wa.me/989124597441" target="_blank">
          <v-btn
              class="black--text mb-3 ml-3  "
              x-large
              color="greenColor"
              elevation="0"
              fab
              fixed
              bottom
              left
          >
            <i class="fab fa-whatsapp contactUs-fab mb-1 ml-1"></i>
          </v-btn>
        </a>
      </v-fab-transition>
    </div>
  </v-app>
</template>
<script>


  export default {
    name: 'App',


    data: () => ({
      //
    }),
  };
</script>
